import React from "react";
import ParticleBlob from "./ParticleBlob";
import { Section, Button, Kicker } from "./primitives";
import CreditWorkbench from "./CreditWorkbench";
import { hero, trust } from "../mock/inferraData";

export default function Hero() {
  return (
    <Section id="top" bg="var(--cream)" pt={120} pb={110} style={{ overflow: "hidden" }}>
      {/* floating blobs */}
      <div
        className="anim-float"
        style={{ position: "absolute", top: 4, right: "1%", opacity: 1, pointerEvents: "none" }}
      >
        <ParticleBlob
          size={400}
          density={95}
          blobs={[
            { x: 0.42, y: 0.4, r: 0.26 },
            { x: 0.62, y: 0.55, r: 0.2 },
            { x: 0.5, y: 0.68, r: 0.16 },
          ]}
        />
      </div>

      <div style={{ paddingTop: 40 }}>
        <Kicker style={{ display: "block", marginBottom: 26 }} className="reveal">
          {hero.kicker}
        </Kicker>

        <div className="hero-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 70 }}>
          <h1
            className="font-type reveal"
            style={{
              margin: 0,
              maxWidth: 820,
              fontSize: "clamp(44px, 6.6vw, 96px)",
              fontWeight: 700,
              lineHeight: 0.99,
              letterSpacing: "-2px",
            }}
          >
            {hero.heading}
          </h1>

          <div className="reveal d1" style={{ width: 400, maxWidth: "100%", flexShrink: 0, paddingBottom: 8 }}>
            <p style={{ margin: 0, fontSize: 18, lineHeight: 1.6, color: "var(--ink-soft)" }}>
              {hero.body}
            </p>
            <div style={{ display: "flex", gap: 12, marginTop: 28, flexWrap: "wrap" }}>
              <Button href={hero.primary.href} variant="solid" arrow>
                {hero.primary.label}
              </Button>
              <Button href={hero.secondary.href} variant="outline">
                {hero.secondary.label}
              </Button>
            </div>
          </div>
        </div>

        {/* dashboard */}
        <div className="reveal d2" style={{ marginTop: 70 }}>
          <CreditWorkbench />
        </div>

        {/* trust */}
        <div
          className="trust-row reveal"
          style={{
            marginTop: 74,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 56,
          }}
        >
          <p style={{ margin: 0, width: 380, fontSize: 14.5, lineHeight: 1.55, color: "var(--ink-soft)" }}>
            {trust.note}
          </p>
          <div
            className="font-type trust-logos"
            style={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 28,
              fontSize: "clamp(18px, 2vw, 30px)",
              color: "#3a453f",
              letterSpacing: "-0.3px",
            }}
          >
            {trust.logos.map((l) => (
              <span key={l} className="hover-x" style={{ cursor: "default" }}>{l}</span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .hero-row { flex-direction: column; align-items: flex-start; gap: 26px; }
          .trust-row { flex-direction: column; align-items: flex-start; gap: 24px; }
          .trust-logos { flex-wrap: wrap; gap: 20px 32px; justify-content: flex-start; }
        }
      `}</style>
    </Section>
  );
}
